var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaypalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76089 4.03029H9.9921C12.2635 4.03029 13.1189 5.18013 12.9867 6.87231C12.769 9.66185 11.0824 11.2044 8.84524 11.2044H7.71588C7.40915 11.2044 7.20293 11.4069 7.11955 11.9578L6.6349 15.1557C6.60326 15.3634 6.4942 15.4855 6.33004 15.5H3.67749C3.42772 15.5 3.33912 15.309 3.40426 14.8955L5.02424 4.63703C5.08901 4.22608 5.31421 4.03029 5.76089 4.03029Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11578 0.5H7.35108C8.5441 0.5 9.9586 0.538713 10.9052 1.37327C11.5373 1.93088 11.8693 2.8194 11.7926 3.77307C11.5328 7.00706 9.59827 8.81836 7.00416 8.81836H4.91517C4.55969 8.81836 4.32406 9.05399 4.22356 9.692L3.64063 13.4002C3.60267 13.6407 3.49844 13.7825 3.30823 13.7996H0.699597C0.409997 13.7996 0.30726 13.5781 0.382824 13.0987L2.26187 1.20353C2.33706 0.727064 2.59763 0.5 3.11578 0.5Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2846 9.31827L5.02424 4.63703C5.08901 4.22608 5.31421 4.03029 5.76089 4.03029H9.9921C10.6926 4.03029 11.2584 4.13973 11.7018 4.3411C11.2767 7.21923 9.41513 8.81836 6.97736 8.81836H4.88837C4.61329 8.81836 4.40781 8.95869 4.2846 9.31827Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalIcon);
export default __webpack_public_path__ + "static/media/PaypalIcon.b48476d10f7e4d89d309970e3fbcaa49.svg";
export { ForwardRef as ReactComponent };